import { IconSprite } from "../../ui/IconSprite/IconSprite";

import { InfoWrapper, Text, Title, Wrapper } from "./WidgetStatus.styled";

export const WidgetStatus = ({
  status = "default",
  title,
  description,
  height,
}) => {
  const isStatusDefault = status === "default";
  const isStatusError = status === "error";
  const isStatusSuccess = status === "success";

  return (
    <Wrapper
      isStatusError={isStatusError}
      isStatusSuccess={isStatusSuccess}
      height={height}
    >
      {isStatusDefault ? (
        <IconSprite tag="widgetDefault" width="225" height="204" />
      ) : (
        <IconSprite tag="widgetChecked" width="240" height="249" />
      )}
      {(title || description) && (
        <InfoWrapper>
          <Title status={status}>{title}</Title>
          <Text status={status}>{description}</Text>
        </InfoWrapper>
      )}
    </Wrapper>
  );
};
